import { Button } from '@bbpos/ui';
import { useAppHealthStore } from '@/stores/use-app-health-store';

export function AppHealthBanner() {
  const catalogSyncError = useAppHealthStore((s) => s.catalogSyncError);
  const cartHydrationError = useAppHealthStore((s) => s.cartHydrationError);
  const locationHydrationError = useAppHealthStore((s) => s.locationHydrationError);
  const shiftHydrationError = useAppHealthStore((s) => s.shiftHydrationError);
  const deviceKeyWarning = useAppHealthStore((s) => s.deviceKeyWarning);
  const storageWarning = useAppHealthStore((s) => s.storageWarning);

  const errors = [
    catalogSyncError && `Catalog sync: ${catalogSyncError}`,
    cartHydrationError && `Cart restore: ${cartHydrationError}`,
    locationHydrationError && `Location: ${locationHydrationError}`,
    shiftHydrationError && `Shift: ${shiftHydrationError}`,
  ].filter(Boolean) as string[];
  // T17: offline-bill safety notices — a reload fixes neither, so no Retry.
  const notices = [deviceKeyWarning, storageWarning].filter(Boolean) as string[];

  if (errors.length === 0 && notices.length === 0) return null;

  return (
    <>
      {errors.length > 0 && (
        <div className="bg-warning-50 dark:bg-warning-900/20 border-b border-warning-200 dark:border-warning-800 px-4 py-2">
          <div className="flex items-center gap-2 text-sm text-warning-700 dark:text-warning-400">
            <span className="font-semibold shrink-0">Data may be stale:</span>
            <span className="truncate">{errors.join(' · ')}</span>
            <Button variant="ghost" size="sm" className="shrink-0 ml-auto" onClick={() => window.location.reload()}>
              Retry
            </Button>
          </div>
        </div>
      )}
      {notices.map((notice) => (
        <div
          key={notice}
          role="status"
          className="bg-gradient-to-r from-warning-50 to-danger-50 dark:from-warning-900/20 dark:to-danger-900/20 border-b border-warning-200 dark:border-warning-800 px-4 py-2 animate-fade-in"
        >
          <p className="text-sm text-warning-800 dark:text-warning-300">{notice}</p>
        </div>
      ))}
    </>
  );
}
